export enum ToastType {
    info,
    success,
    warning,
    error,
    default
}
